const AFFECTED_TIMEZONES = new Set([
  'America/Vancouver',
  'America/Dawson_Creek',
  'America/Fort_Nelson',
  'America/Creston',
  'Canada/Pacific',
  'America/Edmonton',
  'America/Inuvik',
  'America/Yellowknife',
  'Canada/Mountain',
  'America/Winnipeg',
  'Canada/Central',
]);

export const isAffectedTimezone = (timezone) =>
  Boolean(timezone && AFFECTED_TIMEZONES.has(timezone));
